<div class="buttons-over-form mb-3">
  <app-back-button></app-back-button>
</div>
<div class="container-box">
  <app-table-header
    [showUpdateButton]="false"
    [tableTitle]="isNewForm ? 'Nuovo Test Drive' : 'Dettaglio Test Drive'"
  ></app-table-header>
  <div class="content flex flex-wrap">
    <app-button
      (btnClicked)="downloadPdf()"
      *ngIf="showDownloadButton()"
      [color]="'download'"
      [content]="'Scarica PDF Scarico Responsabilità'"
      [faIcon]="faFilePdf"
      [showIcon]="true"
      class="text-right mr-3 mb-3"
    ></app-button>
    <app-test-drive-form [data]="data" [isNewForm]="isNewForm"></app-test-drive-form>
  </div>
</div>
